import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { updateWebUrl, webUrlQueryKeys } from '../api/webUrls.api';
import type { UpdateWebUrlPayload } from '../types/webUrl.types';

interface UpdateWebUrlArgs {
  id: number;
  payload: UpdateWebUrlPayload;
}

export function useUpdateWebUrl(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateWebUrlArgs) => updateWebUrl(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: webUrlQueryKeys.all() });
      toast.success('Web URL updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update web URL');
    },
  });
}
